export const phoneNum = {
  label: "(800) 270-2088",
  value: "+18002702088",
};
